import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_1b974da6";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_1b974da6" };
/** script content **/
require("./loading.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex1b974da6%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fbutton%2Floading%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_1b974da6"],
    ctorType: "component",
    outputPath: "components/index1b974da6/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
